module.exports = __webpack_public_path__ + "static/media/sbi.9e0cadb2.png";